module.exports = __webpack_public_path__ + "static/media/logo-verticality.e667647b.svg";